import React from 'react';
import PropTypes from 'prop-types';
import styles from './EventListingsEventSummaryBox.module.scss';

const EventListingsEventSummaryBox = ({
  title,
  publishDateString,
  imgSrc = null,
  url,
}) => {
  return (
    <div className={styles.container}>
      {imgSrc && (
        <div className={styles['img-container']}>
          <a href={url}>
            <img src={imgSrc} alt={title} />
          </a>
        </div>
      )}
      <div className={styles.description}>
        <div className={styles.description__title}><a href={url} data-testid="description__title">{title}</a></div>
        <div className={styles.description__details}>
          Scheduled to publish on <span className={styles['mobile-clear']} data-testid="description__publish-date">{publishDateString}</span>
        </div>
      </div>
    </div>
  );
};

EventListingsEventSummaryBox.propTypes = {
  title: PropTypes.string.isRequired,
  publishDateString: PropTypes.string.isRequired,
  imgSrc: PropTypes.string,
  url: PropTypes.string.isRequired,
};

export default EventListingsEventSummaryBox;
